import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import 'index.css';
import App from 'containers/App';
import configureStore from 'configureStore';
import { unregister } from 'registerServiceWorker';

const store = configureStore();
ReactDOM.render(<App store={store} />, document.getElementById('root'));
unregister();
